// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'sport1Bold', Sport1-Bold-Fallback"},"className":"__className_c9824b","variable":"__variable_c9824b"};